import { render, staticRenderFns } from "./wholeProcessTrace.vue?vue&type=template&id=6364407c&scoped=true"
import script from "./wholeProcessTrace.vue?vue&type=script&lang=js"
export * from "./wholeProcessTrace.vue?vue&type=script&lang=js"
import style0 from "./wholeProcessTrace.vue?vue&type=style&index=0&id=6364407c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364407c",
  null
  
)

export default component.exports